import { useNavigate } from 'react-router-dom';
import { WARNING_MESSAGE_REQUEST } from 'utils/constant';
import { ROUTES } from 'utils/routeNames';
import { WarningModalWrapper, WarningModalText, WarningModalButton } from './styled';

export const WarningModal = () => {
  const navigate = useNavigate();
  return (
    <WarningModalWrapper>
      <WarningModalText>{WARNING_MESSAGE_REQUEST}</WarningModalText>
      <WarningModalButton onClick={() => navigate(ROUTES.SETTINGS)}>
        Go to Settings
      </WarningModalButton>
    </WarningModalWrapper>
  );
};
